const MenuStoryMode = () => {
    return (
        <div>
            {/* Starts a whole new game and overwrites previous playthrough data */}
            <div>New Player</div>
            {/* Restart from last hacked level */}
            <div>Saved Data</div>
            {/* dark mode, language, difficulty, sound toggle,  */}
            <div>Settings</div>
        </div>
    );
};

export default MenuStoryMode;
